import request from "@/libs/request";
import {
  ReadSpecAnalysisCommoditiesRequest,
  ReadSpecAnalysisCommoditiesResponse,
  SpecReadReagentsResponse,
  SpecReadTypeRequest,
  SpecReadTypeResponse,
  SpecUpdateReagentsRequest,
  SpecUpdateReagentsResponse,
  UpdateSpecAnalysisCommoditiesRequest,
  UpdateSpecAnalysisCommoditiesResponse,
} from "@/types/specs";

// 프로젝트 시약/장비 규격 조회(대체 품목 포함)
export const readSpecsType = async ({
  project_type,
  project_id,
}: SpecReadTypeRequest): Promise<SpecReadTypeResponse> => {
  const response = await request.post<SpecReadTypeResponse>(
    "/spec-analysis/read-type",
    {
      project_type,
      project_id,
    }
  );
  return response.data;
};

export const readSpecsReagents = async ({
  project_type,
  project_id,
}: {
  project_type: string;
  project_id: string;
}): Promise<SpecReadReagentsResponse> => {
  const response = await request.post<SpecReadReagentsResponse>(
    "/spec-analysis/read-reagents",
    {
      project_type,
      project_id,
    }
  );
  return response.data;
};

export const updateSpecsReagents = async ({
  project_type,
  project_id,
  data,
}: {
  project_type: string;
  project_id: string;
  data: SpecUpdateReagentsRequest;
}): Promise<SpecUpdateReagentsResponse> => {
  const response = await request.post<SpecUpdateReagentsResponse>(
    "/spec-analysis/update-reagents",
    {
      project_type,
      project_id,
      ...data,
    }
  );

  return response.data;
};

// 프로젝트 규격 조회 (대체 품목 포함) - 장비
export const readSpecCommodities = async ({
  project_type,
  project_id,
}: ReadSpecAnalysisCommoditiesRequest): Promise<ReadSpecAnalysisCommoditiesResponse> => {
  const response = await request.post<ReadSpecAnalysisCommoditiesResponse>(
    "/spec-analysis/read-commodities",
    {
      project_type,
      project_id,
    }
  );
  return response.data;
};

// 프로젝트 규격 수정 (대체 품목 변경) - 장비
export const updateSpecCommodities = async (
  data: UpdateSpecAnalysisCommoditiesRequest
): Promise<UpdateSpecAnalysisCommoditiesResponse> => {
  const response = await request.post<UpdateSpecAnalysisCommoditiesResponse>(
    "/spec-analysis/update-commodities",
    data
  );

  return response.data;
};
